export enum MessagesHeaderTypes {
  COMPOSE = 'compose',
  NEW = 'new',
  REPLY = 'reply',
  ID = '^\\d+$',
}
